import { RootState } from '@checkout/state';
import { Field } from 'formik';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from '../../../i18n/base-en';
import { Button, InputField } from '../../presentational';
import * as Styles from './PersonalIdentityNumber.scss';

interface IOwnProps {
  id: string;
  name: string;
  onClick: () => void;
}

interface IConnectedProps {}

interface IConnectetDispatchProps {}

interface IOwnState {
  value: string;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class PersonalIdentityNumber extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    value: '',
  };

  handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;

    this.setState({
      value,
    });
  }

  handleFetchData = () => {
    this.props.onClick();
  }

  render() {
    const { id, name, intl } = this.props;
    const { value } = this.state;
    const { formatMessage } = intl;

    return (
      <div className={Styles.inputWrapper}>
        <div className={Styles.input}>
          <Field
            id={id}
            name={name}
            component={InputField}
            value={value}
            type="text"
            variant="simple"
            onChange={this.handleChange}
            submitOnEnter={true}
            label={formatMessage(messages.pin_input_label)}
            placeholder={formatMessage(messages.pin_input_placeholder)}
          />
        </div>
        <Button
          align="left"
          type="button"
          label={formatMessage(messages.pin_fetch_button_label)}
          variant="primary"
          onClick={this.handleFetchData}
        />
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {}
  ),
)(PersonalIdentityNumber);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PersonalIdentityNumber/PersonalIdentityNumber.tsx